// extracted by mini-css-extract-plugin
export default {"melodyVideo":"jM-z","isFullWidth":"kM-z","landingPageVideo":"lM-z","play":"mM-z","iframeVideo":"nM-z","playHidden":"oM-z","fullwidth":"pM-z"};